import managementRedirect from 'src/router/middleware/management/managementRedirect.js'
import auth from 'src/router/middleware/authentification/auth.js'
import schoolYearChangeEnabled from 'src/router/middleware/management/schoolYearChangeEnabled.js'

const SchoolYearChangeWrapper = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeWrapper.vue')
const SchoolYearChangeChooseType = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeChooseType.vue')
const DuplicatedUsers = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeDuplicatedUsers.vue')
const Intro = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeIntro.vue')
const NewUserList = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeNewUserList.vue')
const ConfirmGraduates = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeConfirmGraduates.vue')
const AutomaticallyMatchedUsers = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeAutomaticallyMatchedUsers.vue')
const Summary = () => import('src/views/Management/SchoolYearChange/SchoolYearChangeSummary.vue')

export default [
  {
    path: 'school-year-change-type',
    component: SchoolYearChangeChooseType,
    name: 'school-year-change-type',
    meta: {
      middleware: [auth, managementRedirect, schoolYearChangeEnabled],
      group: 'school-year-change-type',
      headerText: 'global.headers.schoolyearchange'
    }
  },
  {
    path: 'users-compare/:type/',
    component: SchoolYearChangeWrapper,
    name: 'school-year-change',
    meta: {
      middleware: [auth, managementRedirect, schoolYearChangeEnabled],
      group: 'school-year-change-type',
      headerText: 'global.headers.schoolyearchange'
    },
    children: [
      {
        path: 'introduction',
        component: Intro,
        name: 'school-year-change-introduction',
        meta: {
          step: 1,
          group: 'school-year-change-type',
          headerText: 'global.headers.schoolyearchange'
        }
      },
      {
        path: 'remove-duplicated-users',
        component: DuplicatedUsers,
        name: 'remove-duplicated-users',
        meta: {
          step: 2,
          group: 'school-year-change-type',
          headerText: 'global.headers.schoolyearchange'
        }
      },
      {
        path: 'new-users-list',
        component: NewUserList,
        name: 'new-users-list',
        meta: {
          step: 3,
          group: 'school-year-change-type',
          headerText: 'global.headers.schoolyearchange'
        }
      },
      {
        path: 'auto-matches',
        component: AutomaticallyMatchedUsers,
        name: 'auto-matches',
        meta: {
          step: 4,
          group: 'school-year-change-type',
          headerText: 'global.headers.schoolyearchange'
        }
      },
      {
        path: 'confirm-graduates',
        component: ConfirmGraduates,
        name: 'confirm-graduates',
        meta: {
          step: 4,
          group: 'school-year-change-type',
          headerText: 'global.headers.schoolyearchange'
        }
      },
      {
        path: 'confirm-new-students',
        component: ConfirmGraduates,
        name: 'confirm-new-students',
        meta: {
          step: 5,
          group: 'school-year-change-type',
          headerText: 'global.headers.schoolyearchange'
        }
      },
      {
        path: 'summary',
        component: Summary,
        name: 'school-year-change-summary',
        meta: {
          step: 6,
          group: 'school-year-change-type',
          headerText: 'global.headers.schoolyearchange'
        }
      }
    ]
  }
]
